import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';

// Ponte entre o topo do desktop, onde fica o atalho de ofertas, e a tela de produtos,
// dona do modal: os dois sao irmaos no layout e nao se enxergam por @Input/@Output.
@Injectable({
  providedIn: 'root'
})
export class DestaqueAberturaService {
  private readonly disponivel = new BehaviorSubject<boolean>(false);
  private readonly aberturas = new Subject<string>();

  disponivel$: Observable<boolean> = this.disponivel.asObservable();
  aberturaSolicitada$: Observable<string> = this.aberturas.asObservable();

  // a tela de produtos avisa se ha oferta montada; sem isso o topo nao mostra o item
  publiqueDisponibilidade(disponivel: boolean) {
    this.disponivel.next(disponivel);
  }

  solicitouAbertura(origem = 'topo') {
    this.aberturas.next(origem);
  }
}
